import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { API_URL } from '../../../SHARED/config/apiEndpoints';
import Moment from "react-moment";
import 'moment/locale/ro';
import { getSavedNews, getSavedNewsSeeMore, removeNewsFromFavorite} from '../../../SHARED/actions/profile.actions';
import { Link } from 'react-router-dom';
import {slugify} from '../../helpers/general.helper';
import Parser from 'html-react-parser';

class SavedNews extends Component {

    componentWillMount(){
        this.props.getSavedNews();
    }

    removeNewsFromFavorite = (newsId, pager) => {
        this.props.removeNewsFromFavorite({newsId, pager});
    }

    seeMore = () => {
        this.props.getSavedNewsSeeMore(this.props.savedNews.pager.current_page + 1);
    }

    getSeeMoreCondition = () => {
        if(this.props.savedNews.rows){
            return <span onClick={this.seeMore}>{this.props.savedNews.rows.length !== this.props.savedNews.pager.total_items ? "Vezi mai multe..." : "" }</span>
        }
    }

    getTotalItems = () => {
        return  this.props.savedNews.pager ? this.props.savedNews.pager.total_items : 0;
    }

    getContent = () => {
        if (this.props.savedNews.rows){
            return this.props.savedNews.rows.map((card, i) => {
                return <div className="item-saved-news row nopadding" key={i}>
                    <div className="col-lg-3">
                        <Link to={`/stire/${card.article_id}/${slugify(card.article_title)}`} >
                            <img src={API_URL + card.article_image} alt="Știri"/>
                        </Link>
                    </div>
                    <div className="col-lg-9 cinema-dt">
                        <span className="notif-delete" onClick={ () => this.removeNewsFromFavorite(card.favorite_uuid, this.props.savedNews.pager)} />
                        <div className="row no-gutters">
                            <div className="col-lg-8">
                                <Link to={`/stire/${card.article_id}/${slugify(card.article_title)}`} className="white-text">
                                    <span className="saved-news-name float-left">{Parser(card.article_title)}</span>
                                </Link>
                            </div>
                        </div> 
                        <span className="grey-text fs10">
                            <Moment format="DD MMMM YYYY HH:mm" locale="ro" unix>
                                { card.article_created }
                            </Moment>
                        </span>
                        <div className="row no-gutters">
                            <div className="all-details col-xl-11">
                                <span className="white-text">{Parser(card.article_summary)}</span>
                            </div>
                            <div className="col-xl-1">&nbsp;</div>
                        </div>
                    </div>
                </div>
            });
        }
    };

    render() {
        return (
            <Fragment>
                <div className="profile-item-header ">
                    <span className="icon-saved-news float-left" />
                    <span className="profile-notif-summary">Știri salvate de tine ({this.getTotalItems()})</span>
                </div>
                <div className="saved-news">
                    {this.getContent()}
                </div>
                <div className="col see-more nopadding">
                    {this.getSeeMoreCondition()}
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    savedNews: state.profile.savedNews
});
export default connect(mapStateToProps, { getSavedNews, getSavedNewsSeeMore, removeNewsFromFavorite})(SavedNews);


// WEBPACK FOOTER //
// ./src/SHARED/components/savednews/savednews.component.js